import React, { useState, useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';
import throttle from 'lodash.throttle';
import { collectEventfireGa4, getGa4PageViewSet } from 'utils/common';

const StoryBlockerPopUpContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  z-index: 99999;
  left: 0;
  bottom: -100%;
  width: 100%;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  transition: all .8s ease;
  ${(props: any) => props.isOpen == true && css`
  bottom: 0;
  visibility: visible;
`}
  
`;

const Content = styled.div`
  padding: 20px;
  ${(props: any) => props.mobile === true && css`
    padding: 8px;
`}
  @media screen and (max-width: 1366px) and (min-width: 1180px) {
      padding: 16px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 100px;
  transform: translateY(-50%);
  font-size: 18px;
  background: #fff;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-indent: -9999px;
  ${(props: any) => props.mobile === true && css`
    width: 24px;
    height: 24px;
    right: 6px;
    top: 18px;
    background: #FFF0EC;
`}
  &:before, &:after {
    background: #4D4D4D;
    content: "";
    height: 1px;
    left: 11px;
    position: absolute;
    top: 17px;
    transition: all .5s;
    width: 16px;
    ${(props: any) => props.mobile === true && css`
        width: 12px;
        height: 2px;
        left: 7px;
        top: 12px;
    `}
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(135deg);
  }
`;

const BlockerTransparentBg = styled.div`
    position: fixed;
    background: rgba(0, 0, 0, .5);
    width: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
`;
interface IStoryBlockerPopUpProps {
  children: React.ReactNode;
  isWapView: boolean;
  msid: string;
  closePopUpRef: any
}

const StoryBlockerPopUp: React.FC<IStoryBlockerPopUpProps> = (props: IStoryBlockerPopUpProps) => {
  const { children, isWapView, msid, closePopUpRef } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isClosed, isPopUpAlreadyClosed] = useState<boolean>(false);

  const handleScroll = () => {
    if (!isClosed) {
      setIsOpen(true);
      document.body.style.overflow = "hidden";
    }
  };

  const throttledHandleScroll = useCallback(throttle(handleScroll, 100), [handleScroll]);

  useEffect(() => {
    window.addEventListener('scroll', throttledHandleScroll);
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [isClosed]);

  useEffect(() => {
    if (closePopUpRef) {
      closePopUpRef.current = closePopUp;
    }
  }, []);


  const fireGA4 = (obj?: any) => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      'event': obj?.action === 'click' ? 'select_item' : 'view_item_list',
    }
    return collectEventfireGa4(collatedGadata,
      {
        item_name: window.location.href.indexOf('.cms') > -1 ? document.title : window.location.href,
        item_id: msid ? msid : '',
        item_brand: 'product_interventions',
        item_category: 'Nudges',
        item_category2: 'articleshow',
        item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
        item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      });
  }


  const closePopUp = (e: any, fireCloseGA = true) => {
    setIsOpen(false);
    isPopUpAlreadyClosed(true);
    document.body.style.overflow = "";
    if (fireCloseGA) {
      fireGA4({
        action: 'click',
        item_category4: e.target.innerText || '',
        item_category3: 'paywall_bottomsheet_blocker_cta_cross',
      })
    }
  };

  return (
    <div>
      {isOpen && <BlockerTransparentBg />}
      <StoryBlockerPopUpContainer isOpen={isOpen}>
        <CloseButton mobile={isWapView} onClick={(e) => closePopUp(e)}>×</CloseButton>
        <Content mobile={isWapView}>
          {children}
        </Content>
      </StoryBlockerPopUpContainer>
    </div>
  );
};

export default StoryBlockerPopUp;
